import request from '@/utils/request'
// 大会接口

// 简介
export function getSynopsis (query) {
    return request({
        url: 'conference/notcheck/synopsis',
        method: 'get',
        params: query
    })
}

// 详情
export function getConferenceInfo (query) {
    return request({
        url: 'conference/notcheck/get',
        method: 'get',
        params: query
    })
}

// 嘉宾参会须知
export function getGusetInstruction (query) {
    return request({
        url: 'conference/notcheck/instruction/guest',
        method: 'get',
        params: query
    })
}

// 嘉宾确认参会
export function getGuestConfirm (query) {
    return request({
        url: 'conference/notcheck/confirm/guest',
        method: 'get',
        params: query
    })
}

// 媒体参会须知
export function getMediaInstruction (query) {
    return request({
        url: 'conference/notcheck/instruction/media',
        method: 'get',
        params: query
    })
}

// 媒体确认参会
export function getMediaConfirm (query) {
    return request({
        url: 'conference/notcheck/confirm/media',
        method: 'get',
        params: query
    })
}

// 缴费嘉宾须知
export function getPaymentInstruction (query) {
    return request({
        url: 'conference/notcheck/instruction/payment',
        method: 'get',
        params: query
    })
}

// 缴费嘉宾确认参会
export function getPaymentConfirm (query) {
    return request({
        url: 'conference/notcheck/confirm/payment',
        method: 'get',
        params: query
    })
}

export function getCheckLocation (query) {
    return request({
        url: 'conference/notcheck/checkLocation',
        method: 'get',
        params: query
    })
}
